import { ReactNode } from "react";
import Flex from "./Flex";

export const FlexCenterWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      flexDirection={"column"}
      height={"100%"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={1}
    >
      {children}
    </Flex>
  );
};
